// Corporate-unit classification for the intake form's Business Unit / Department
// split (intake change 2). The three "Corporate …" entries are operating in the
// business_units table but represent DEPARTMENTS, not business units, so they are
// filtered out of the Business Unit dropdown and offered under Department instead.
//
// R2 fix (2026-07-20): the live config values are "Corporate - General",
// "Corporate - IT", "Corporate - Marketing" — WITH a " - " separator. An earlier
// hardcoded dashless list ("Corporate General" …) never matched, so the filter was
// a no-op in production. Match dash-agnostically by the "Corporate" prefix and seed
// the Department dropdown from the SAME live values, so the two can never drift and
// no hardcoded name guess can go stale.

export function isCorporateUnit(name: string | null | undefined): boolean {
  return /^\s*corporate\b/i.test(name || "");
}

// Split a live business-units list into operating units (Business Unit dropdown)
// and corporate departments (Department dropdown) from one source of truth.
export function partitionBusinessUnits<T extends { name: string }>(
  units: T[] | null | undefined
): { operating: T[]; corporate: T[] } {
  const operating: T[] = [];
  const corporate: T[] = [];
  for (const u of units || []) {
    (isCorporateUnit(u.name) ? corporate : operating).push(u);
  }
  return { operating, corporate };
}
